import { CheckCircle2 } from "lucide-react";

type Props = {
  icon: typeof CheckCircle2;
  label: string;
  value: number | string;
};

export function CertificationOverviewCard({ icon: Icon, label, value }: Props) {
  return (
    <article className="iso27001-overview-card">
      <span className="iso27001-overview-card-icon" aria-hidden="true">
        <Icon size={18} />
      </span>
      <div className="iso27001-overview-card-copy">
        <div className="iso27001-overview-card-label">{label}</div>
        <div className="iso27001-overview-card-value">{value}</div>
      </div>
    </article>
  );
}
